import { render, staticRenderFns } from "./AppointmentBookingDetails.vue?vue&type=template&id=15564259"
import script from "./AppointmentBookingDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentBookingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports